import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { reduxForm } from 'redux-form';

import InlineNotification from '../../../components/InlineNotification';

const FORM_ID = 'MakeUserAdminModal';

class MakeUserAdminModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handleSubmit() {
    const { user, makeUserAdminFn } = this.props;
    return makeUserAdminFn(user.username).then(() => {
      this.closeModal();
    });
  }

  closeModal() {
    this.props.destroy();
    this.props.closeModalFn();
  }

  render() {
    if (!this.props.show) {
      return null;
    }
    const { handleSubmit, user, show, error } = this.props;
    return (
      <Modal show={show} onHide={this.closeModal}>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>Make User an Admin</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <p>
              You're about to assign admin privileges to user <strong>{user.username}</strong>.
            </p>
            <p>
              Proceed with caution, this action have <strong>security implications.</strong>
            </p>
            {error && <InlineNotification type="danger">{error}</InlineNotification>}
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center">
              <Button
                type="submit"
                bsSize="large"
                disabled={this.props.submitting}
                bsStyle="danger"
              >
                Make user an admin
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

MakeUserAdminModal.propTypes = {
  show: PropTypes.bool.isRequired,
  makeUserAdminFn: PropTypes.func.isRequired,
  closeModalFn: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default reduxForm({
  form: FORM_ID,
})(MakeUserAdminModal);
